// import React, { useEffect, useState } from "react";
// import img1 from "../../assets/images/small/img-1.jpg";
// import { Field } from "formik";

// const ImageComponent = ({
//   fileId,
//   size,
//   className,
//   alt,
//   style: customStyle,
// }) => {
//   const [imageUrl, setImageUrl] = useState(img1);
//   const style = {
//     backgroundImage: `url(${imageUrl})`,
//     backgroundSize: "cover",
//     backgroundRepeat: "no-repeat",
//     backgroundPosition: "center",
//     overflow: "hidden",
//     ...customStyle,
//   };
//   console.log(style);

//   useEffect(() => {
//     if (fileId == "") {
//       return;
//     }
//     const cachedUrl = localStorage.getItem(fileId);

//     if (cachedUrl) {
//       setImageUrl(cachedUrl);
//     } else {
//       const url = `${window.APP_CONFIG.cdnurl}/${fileId}`;
//       //const url = `https://drive.google.com/thumbnail?id=${fileId}&sz=w400`;
//       //const url = `https://lh3.googleusercontent.com/d/${fileId}w400?authuser=0`;
//       localStorage.setItem(fileId, url);
//       setImageUrl(url);
//     }
//   }, [fileId]);

//   return (
//     <>
//       {imageUrl ? (
//         <div className={className} alt={alt} style={style}></div>
//       ) : (
//         <span>Loading image...</span>
//       )}
//     </>
//   );
// };

// export default ImageComponent;


import React, { useEffect, useState } from "react";
import img1 from "../../assets/images/small/img-1.jpg";

const ImageComponent = ({
  fileId,
  size,
  className,
  alt,
  style: customStyle,
}) => {
  console.log("🚀 ~ alt:", alt)
  console.log("🚀 ~ fileId:", fileId)
  const [imageUrl, setImageUrl] = useState(img1);

  const style = {
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    overflow: "hidden",
    ...customStyle,
  };

  useEffect(() => {
    if (fileId == '') { return; }
    const cachedUrl = localStorage.getItem(fileId);
    if (cachedUrl) {
      setImageUrl(cachedUrl);
    } else {
      const url = `${window.APP_CONFIG.cdnurl}/${fileId}`;
      localStorage.setItem(fileId, url);
      setImageUrl(url);
    }
  }, [fileId]);

  return (
    <>
      {imageUrl ? (
        <div
          className={className}
          style={style}
          role="img"
          aria-label={alt || "Image"}
        ></div>
      ) : (
        <span>Loading image...</span>
      )}
    </>
  );
};

export default ImageComponent;